import { Modal } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { Button, Divider, Grid, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Done from "../../assets/images/done.gif";
import QRCode from "qrcode.react";
import { getPurchaseTickets } from "../../api/events";
import { useParams } from "react-router";

const TicketSummaryModal = ({ eventDetails, onOpen, onClose, classes }) => {
  const { id: eventId } = useParams();
  const orderId = new URLSearchParams(window.location.search).get("orderId");

  const [fetching, setFetching] = useState(true);
  const [payeeInfo, setPayeeInfo] = useState(null);
  const [summary, setSummary] = useState([]);

  useEffect(() => {
    const fetchVerification = async () => {
      const verificationRes = await getPurchaseTickets(eventId, orderId);
      setFetching(false);

      console.log("verify ", verificationRes);
      if (verificationRes.status === false) {
        console.log("event verification failed", verificationRes);
        setFetching(false);
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname +
            `?status=false${
              orderId ? `&orderId=${orderId}` : ""
            }&message=Unable to verify payment. Please contact support.`
        );

        onClose();
      } else {
        const { data } = verificationRes;
        if (data.status === "APPROVED") {
          console.log("verification approved");
          console.log("data", data);
          const { payeeInfo } = data;
          setPayeeInfo(payeeInfo);

          const ticketsInfo = payeeInfo.ticketsQuantity || [];
          console.log("ticketsInfo", ticketsInfo);

          const summary = [];
          ticketsInfo.forEach((purchased) => {
            if (purchased.quantity <= 0) return;

            const ticketInfo = eventDetails.eventtickets.find(
              (ticket) => ticket.id === purchased.id
            );
            if (ticketInfo) {
              summary.push({
                title: ticketInfo.title,
                quantity: `${purchased.quantity} x ${ticketInfo.price}`,
                amount: Number(ticketInfo.price) * Number(purchased.quantity),
              });
            }
          });
          console.log("summary", summary);
          setSummary(summary);
        } else if (data.status === "REJECTED") {
          console.log("verification rejected");
          window.history.replaceState(
            {},
            document.title,
            window.location.pathname +
              `?status=false${
                orderId ? `&orderId=${orderId}` : ""
              }&message=Unable to verify payment. Please contact support.`
          );

          onClose();
        } else if (data.status === "PENDING") {
          console.log("verification pending");

          window.history.replaceState(
            {},
            document.title,
            window.location.pathname +
              `?status=false${
                orderId ? `&orderId=${orderId}` : ""
              }&message=Payment verification is pending. Please contact support.`
          );

          onClose();

          // set interval and reload the page
          // setTimeout(() => {
          //   window.location.reload();
          // }, 10000);
        }
      }
    };
    if (fetching && eventId && orderId) {
      console.log("calling verify api");
      fetchVerification();
    }
  }, [eventId, orderId, fetching]);

  return (
    <Modal open={onOpen} onClose={onClose}>
      <div style={getModalStyle()} className={classes.paper}>
        <Grid container spacing={2}>
          {/* top gig */}
          <Grid
            item
            xs={12}
            style={{ paddingTop: "10px", paddingBottom: "10px" }}
          >
            <Grid container justify="center">
              <img
                style={{
                  height: "4rem",
                }}
                src={Done}
                alt=""
              />
            </Grid>
          </Grid>
          {/* heading */}
          <Grid item xs={12} style={{ marginTop: "1rem" }}>
            <Grid container justify="center">
              <Typography
                style={{
                  fontSize: 18,
                  color: "#CBA25A",
                  fontWeight: 300,
                  fontFamily: "sans-serif",
                }}
              >
                YOUR PAYMENT IS SUCCESSFULL
              </Typography>
            </Grid>
          </Grid>
          {/* subheading */}
          <Grid xs={12}>
            <Grid container justify="center">
              <Typography style={{ fontSize: 9.5, fontWeight: 300 }}>
                YOU WILL GET AN EMAIL WITH YOUR ORDER SUMMARY
              </Typography>
            </Grid>
          </Grid>
          {/* payee info and QR */}
          {payeeInfo && (
            <Grid item xs={12} style={{ margin: "1rem" }}>
              <Grid container justify="center" alignItems="center">
                {/* payeeInfo */}
                <Grid item xs={12} md={6}>
                  <Grid
                    container
                    spacing={1}
                    justify="center"
                    alignItems="bottom"
                  >
                    <Grid item xs={12}>
                      <Grid container>
                        <span style={{ fontWeight: 600 }}>NAME: </span>{" "}
                        <span
                          style={{
                            marginLeft: "0.5rem",
                            fontWeight: 300,
                            textTransform: "uppercase",
                          }}
                        >
                          {payeeInfo.name}
                        </span>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container>
                        <span style={{ fontWeight: 600 }}>PHONE: </span>{" "}
                        <span
                          style={{
                            marginLeft: "0.5rem",
                            fontWeight: 300,
                            textTransform: "uppercase",
                          }}
                        >
                          {payeeInfo.phone}
                        </span>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container>
                        <span style={{ fontWeight: 600 }}>EMAIL: </span>{" "}
                        <span
                          style={{
                            marginLeft: "0.5rem",
                            fontWeight: 300,
                            textTransform: "lowercase",
                          }}
                        >
                          {payeeInfo.email}
                        </span>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                {/* locationQR */}
                <Grid item xs={12} md={6}>
                  <Grid container justify="center">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",

                        marginTop: "15px",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "12px",
                          fontWeight: 800,
                        }}
                      >
                        SCAN FOR LOCATION
                      </p>
                      <a
                        rel="noreferrer"
                        href={eventDetails.locationURL}
                        target="_blank"
                      >
                        <QRCode size={80} value={eventDetails.locationURL} />
                      </a>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}
          {/* ticket summary */}
          {summary && (
            <Grid item xs={12}>
              <Typography
                style={{ fontSize: 14, fontWeight: 600, color: "#CBA25A" }}
              >
                TICKET SUMMARY
              </Typography>
              <table
                style={{
                  marginTop: "1rem",
                  textAlign: "center",
                  width: "100%",
                  borderCollapse: "collapse",
                  borderSpacing: 0,
                }}
              >
                <tbody>
                  {summary.map((ticket, index) => (
                    <tr key={index}>
                      <td>{ticket.title}</td>
                      <td>{ticket.quantity}</td>
                      <td>AED {ticket.amount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <Divider style={{ backgroundColor: "black" }} />
            </Grid>
          )}
          {/* total amount */}
          {payeeInfo && (
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={8}>
                  <Typography
                    style={{ fontSize: 14, fontWeight: 600, color: "#CBA25A" }}
                  >
                    TOTAL AMOUNT
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Grid container justify="center">
                    <Typography style={{ fontSize: 14, fontWeight: 600 }}>
                      AED {payeeInfo.amount}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}
          {/* close */}
          <Grid item xs={12} style={{ marginBottom: "1rem" }}>
            <Grid container justify="center">
              <Button
                style={{
                  backgroundColor: "#CBA25A",
                  color: "white",
                  width: "13rem",
                  height: "2rem",
                  borderRadius: "0.5rem",
                }}
                onClick={onClose}
              >
                <Typography style={{ fontSize: 13 }}>CLOSE</Typography>
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </Modal>
  );
};

TicketSummaryModal.propTypes = {
  classes: PropTypes.object.isRequired,
};

function rand() {
  return Math.round(Math.random() * 15) - 10;
}

function getModalStyle() {
  const top = 50; // + rand();
  const left = 50; // + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,

    backgroundColor: "white",
  };
}

const styles = (theme) => ({
  paper: {
    position: "absolute",
    width: theme.spacing.unit * 40,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 3,
    outline: "none",
    borderRadius: "10px",

    [theme.breakpoints.up("md")]: {
      width: theme.spacing.unit * 60,
    },
  },
});

export default withStyles(styles)(TicketSummaryModal);
